<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">{{$t('B0300.title')}}</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ol>
          <li>INV P/L输入画面允许固定格式的数据上传（格式请参照【STC SJL 側提供資料】-【INV PL SA】-【upInvice.xls】（上传数据需要做有效性check，比如Item是否存在在Master中）</li>
          <li>INV P/L的输入信息“有偿”的所有I/V商品信息必须从P/O中引用</li>
          <li>“无偿”商品允许直接添加输入行进行数据手工输入</li>
          <li>P/L 的登录的箱号及箱数信息进行check， Carton End No. - Carton Start No. = 数量</li>
          <li>P/L信息中的“识别号”的使用方法
            <ul>
              <li>A. 当复数不同的货物（Item）被放在同一个箱号的一个箱子中时，此处放入此箱中复数货物行的“识别号”为相同的数字</li>
              <li>B. 当复数或单独的货物被放在相同箱号且实际箱体为复数的包装箱的时候，“识别号”为不同的数字（此时箱号相同）</li>
            </ul>
          </li>
        </ol>
        <div style="color:red">
          <h3>2018 12 11</h3>
          <ul>
            <li>1）添加PO字段（Hand PO标记），PO No手动添加的，非SAP过来的。纳入（DO確定后）接口用</li>
            <li>2）【無償商品登録行追加】 按钮，是否改为商品登录（有偿商品是否可以从这里添加，还是有偿商品只能从PO来？），还有待Alex和日方确认</li>
          </ul>
        </div>

        <div style="color:red">
          <h3>2018 12 20</h3>
          <ul>
            <li>【無償商品登録行追加】按钮添加的SKU，不能填写PO No，从SAP接口来的PO No不能修改</li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      username: null,
      password: null
    }
  }
}
</script>
<style scoped>
.login {
  position: absolute;
  top: 100px;
  right: 300px;
  width: 400px;
}
</style>
